import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Vocation = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3 ">
        <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414]">Пізнай Своє Покликання (ПСП)</h1>
        <div className="text-justify hyphens-auto" id="section1">
          <div className="pt-3 pb-3 leading-relaxed">
            Однією з форм наслідування Христа та служіння людям є монашество (богопосвячене життя). Часто ми боїмося цього слова, але насправді його боятися не варто, адже Ісус говорить:
            «Не ви Мене вибрали, а Я вибрав вас…»
            А це означає, що ініціатива кожного покликання належить тільки Господу.
            <br /> <br /><span className="text-[#A81414] font-bold">
              «Пізнай своє покликання» — це щомісячні зустрічі для хлопців, які роздумують над своїм життєвим шляхом. Метою цих зустрічей є допомогти учасникам дізнатися про різні види покликань, глибше зрозуміти й розпізнати власне. Важливим елементом цього процесу є молитовне та літургійне життя, знайомство з духовністю Згромадження і молодіжною салезіянською духовністю.
            </span>
            <br /> <br />
            Пізнання монашого покликання може мати різні прояви. Воно може відчуватися в серці як прагнення глибшого служіння Богові — внутрішній поклик душі. Іноді це відбувається через прочитане Боже Слово або через зустріч із людьми, зокрема богопосвяченими особами. Проте у будь-якому разі це рішення потрібно приймати у спокої та чесності перед Богом і собою. А найважливішою частиною цього процесу є щира молитва за правильний вибір життєвої дороги.
            <div className="pt-3 pb-3 font-semibold text-[#A81414]">Молитва про розпізнання покликання:</div>
            <div className="italic font-light pt-3 border-l-4 border-[#A81414] pl-6">Боже, Ти створив мене для щастя, допоможи мені його віднайти. Вкажи мені мій життєвий шлях; вчини, щоб я вибрав те, що Ти для мене приготував і до чого мене покликав з лона матері. Хочу слухати Тебе в усьому; піду туди, куди Ти мене покличеш; прагну Тобі беззастережно довіряти, бо знаю, що Ти мене любиш і хочеш мого добра. Прошу Тебе, веди мене своїми стежками. Амінь.</div>
            <br /> <br />
            <div className="text-[#A81414] font-semibold">
              Душпастирство покликань
            </div>
            <div className="text-[#A81414] font-semibold">
              Провінція Марії Помічниці Християн
            </div>
            <div className="text-[#A81414] font-semibold">
              вул. Личаківська, 175
            </div>
            <div className="text-[#A81414] font-semibold">
              місто Львів
            </div>
            <div className="text-[#A81414] font-semibold">
              Провінційний Настоятель, отець Михайло Чабан, СДБ
            </div>
            <div className="text-[#A81414] font-semibold">
              Тел: +38 067 889 07 70
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Vocation;
